


































































import { Component, Vue } from 'vue-property-decorator';
import Share from '@/components/Share.vue';
import AnswerDialog from '@/components/AnswerDialog.vue';
import RuleDialog from '@/components/RuleDialog.vue';
import RecordDialog from '@/components/RecordDialog.vue';
import GetVCodeDialog from '@/components/GetVCodeDialog.vue';
import AnswerFailDialog from '@/components/AnswerFailDialog.vue';
import AnswerSuccessDialog from '@/components/AnswerSuccessDialog.vue';
import AnswerSuccessAndGetDialog from '@/components/AnswerSuccessAndGetDialog.vue';
import AnswerFellDialog from '@/components/AnswerFellDialog.vue';
import { Toast } from 'vant';

@Component({
    components: {
        'share': Share,
        'answer-dialog': AnswerDialog,
        'rule-dialog': RuleDialog,
        'record-dialog': RecordDialog,
        'get-vcode-dialog': GetVCodeDialog,
        'answer-fail-dialog': AnswerFailDialog,
        'answer-success-dialog': AnswerSuccessDialog,
        'answer-success-and-get-dialog': AnswerSuccessAndGetDialog,
        'answer-fell-dialog': AnswerFellDialog,
    }
})
export default class Home extends Vue {

    //选择的图形
    public checked_graphs: number[] = [];
 
    //最大选择数量
    public readonly MAX_CHECKED_COUNT: number = 3;

    //图形是否被选中
    public isCheckedGraph(index: number): boolean {
        for (let i in this.checked_graphs) {
            if (index == this.checked_graphs[i]) {
                return true
            }
        }
        return false
    }

    //选中图形
    public checkedGraph(index: number): void {
        let n = -1
        for (let i in this.checked_graphs) {
            if (index == this.checked_graphs[i]) {
                n = Number(i)
                break
            }
        }

        if (n <= -1) {
            this.checked_graphs.push(index)
        } else {
            this.checked_graphs.splice(n, 1)
        }

        if (this.checked_graphs.length > this.MAX_CHECKED_COUNT) {
            this.checked_graphs.shift()
        }
    }

    //开始答题
    public onPlay(): void {
        if (this.checked_graphs.length >= this.MAX_CHECKED_COUNT) {
            (this.$refs.answer_dialog as AnswerDialog).open();
        } else {
            Toast("请选择3个图形");
        }
    }

    //打开活动规则
    public onRuleBtn(): void {
        (this.$refs.rule_dialog as RuleDialog).open();
    }

    //打开红包记录
    public onRecordBtn(): void {
        (this.$refs.record_dialog as RecordDialog).open();
    }

    //监听答题成功
    public onAnswerSuccess(): void {
        let game_status = this.$game_data.game_status;

        let hint_string = "";
        if (game_status == 3) {
            //今天已经领取
            if (this.$game_data.is_game_end == 1) {
                hint_string = "您已领取过今日答题红包，感谢您的参与～";
            } else {
                hint_string = "您已领取过今日答题红包，记得明日再来哦";
            }
            (this.$refs.answer_success_dialog as AnswerSuccessDialog).openDialog(hint_string);
        } else if (game_status == 5) {
            //今日红包已经领取完
            if (this.$game_data.is_game_end == 1) {
                hint_string = "今日红包已瓜分完毕，感谢您的参与～";
            } else {
                hint_string = "今日红包已瓜分完毕，明日再来吧～";
            }
            (this.$refs.answer_success_dialog as AnswerSuccessDialog).openDialog(hint_string);
        }  else {
            if (this.$game_data.is_game_end == 1) {
                hint_string = "您已成功赢取今日答题红包，感谢您的参与～";
            } else {
                hint_string = "您已成功赢取今日答题红包，明日再来吧";
            }
            (this.$refs.answer_success_and_get_dialog as AnswerSuccessAndGetDialog).openDialog(hint_string);
        }
    }

    //监听答题失败
    public onAnswerFail(): void {
        (this.$refs.answer_fail_dialog as AnswerFailDialog).open();
    }

    //重新开始
    public reset(): void {
        this.checked_graphs = [];
    }

    //打开分享弹窗
    public openShareDialog(): void {
        (this.$refs.share as Share).open();
    }

    //打开验证弹窗
    public openVerifyDialog(): void {
        (this.$refs.get_vcode_dialog as GetVCodeDialog).open();
    }

    //监听验证成功
    public onVerifySuccess(money: number): void {
        (this.$refs.answer_fell_dialog as AnswerFellDialog).openDialog(money);
        //更改状态
        Vue.prototype.$game_data.game_status = 3;
    }

    //监听弹窗关闭跳转到首页
    public onCloseDialog(): void {
        this.$router.replace("/");
    }
}
